import React, { useState, useEffect, useMemo } from "react";
import StepNavigation from "./StepNavigation";
import { useTranslation } from 'react-i18next';
import LocationPickerMap from "./LocationPickerMap";
import "../../styles/steps.css";

const GEO_ONLY_REGEX = /^[\u10A0-\u10FF\s.,\-'"()0-9]*$/;
const EN_GEO_REGEX = /^[A-Za-z\u10A0-\u10FF\s.,\-'"()0-9]*$/;

/* CITY / MUNICIPALITY OPTIONS */
const CITY_OPTIONS = [
  { key: "tbilisi" },
{ key: "batumi" },
{ key: "kutaisi" },
{ key: "rustavi" },
{ key: "zugdidi" },
{ key: "telavi" },
{ key: "gori" },
{ key: "bakuriani" },
{ key: "borjomi" },
{ key: "gudauri" },
{ key: "abasha" },
{ key: "ambrolauri" },
{ key: "abkhazia" },
{ key: "akhaldaba" },
{ key: "akhaltsikhe" },
{ key: "akhmeta" },


  { key: "ambrolauri_municipality" },
{ key: "adigeni_municipality" },
{ key: "akhaltsikhe_municipality" },
{ key: "akhalgori_municipality" },
{ key: "akhalkalaki_municipality" },
{ key: "akhmeta_municipality" },
{ key: "aspindza_municipality" },

{ key: "bagdadi" },
{ key: "bolnisi" },

{ key: "baghdati_municipality" },
{ key: "bolnisi_municipality" },
{ key: "borjomi_municipality" },


  /* ───── C ───── */
  { key: "ckhinvali" },
{ key: "chiatura" },
{ key: "chokhatauri_municipality" },
{ key: "chkhorotsku_municipality" },

/* ───── D ───── */
{ key: "dmanisi" },
{ key: "dedoplistskaro" },
{ key: "dusheti" },

{ key: "dedoplistskaro_municipality" },
{ key: "dusheti_municipality" },
{ key: "dmanisi_municipality" },

/* ───── F ───── */
{ key: "foti" },


  /* ───── G ───── */
  { key: "gardabani" },
{ key: "gurjaani" },

{ key: "gardabani_municipality" },
{ key: "gori_municipality" },
{ key: "gurjaani_municipality" },

/* ───── J ───── */
{ key: "java" },

/* ───── K ───── */
{ key: "kaspi" },
{ key: "kareli" },
{ key: "kobuleti" },
{ key: "kazbegi" },
{ key: "kvareli" },
{ key: "khashuri" },
{ key: "khevsureti" },
{ key: "khelvachauri" },
{ key: "khobi" },
{ key: "khoni" },

{ key: "khoni_municipality" },
{ key: "khulo_municipality" },
{ key: "khashuri_municipality" },
{ key: "khelvachauri_municipality" },
{ key: "khobi_municipality" },
{ key: "kutaisi_municipality" },
{ key: "kareli_municipality" },
{ key: "kaspi_municipality" },
{ key: "kobuleti_municipality" },
{ key: "kazbegi_municipality" },
{ key: "kvareli_municipality" },
{ key: "kharagauli_municipality" },
{ key: "keda_municipality" },

/* ───── L ───── */
{ key: "lagodekhi" },
{ key: "lanchkhuti" },
{ key: "lentekhi_municipality" },
{ key: "lanchkhuti_municipality" },
{ key: "lagodekhi_municipality" },

{ key: "manglisi" },
{ key: "marneuli" },
{ key: "martvili" },
{ key: "mestia" },
{ key: "mtskheta" },

{ key: "mtskheta_municipality" },
{ key: "mestia_municipality" },
{ key: "martvili_municipality" },
{ key: "abashi_municipality" },
{ key: "marneuli_municipality" },

{ key: "ninotsminda" },
{ key: "ninotsminda_municipality" },


/* ───── O ───── */
{ key: "oni" },
{ key: "oni_municipality" },
{ key: "ozurgeti" },
{ key: "ozurgeti_municipality" },

{ key: "sachkhere" },
{ key: "senaki" },
{ key: "sagarejo" },
{ key: "samtredia" },
{ key: "signagi" },

{ key: "sachkhere_municipality" },
{ key: "senaki_municipality" },
{ key: "sagarejo_municipality" },
{ key: "sighnaghi_municipality" },
{ key: "shuakhevi_municipality" },
{ key: "samtredia_municipality" },


/* ───── T ───── */
{ key: "tskhinvali_district" },
{ key: "tetritskaro" },
{ key: "terjola" },
{ key: "tkibuli" },
{ key: "tsageri" },
{ key: "tsalenjikha" },
{ key: "tsalka" },
{ key: "tsnori" },
{ key: "tskaltubo" },

{ key: "tkibuli_municipality" },
{ key: "terjola_municipality" },
{ key: "tetritskaro_municipality" },
{ key: "telavi_municipality" },
{ key: "tsalka_municipality" },
{ key: "tsalenjikha_municipality" },
{ key: "tsageri_municipality" },
{ key: "tskaltubo_municipality" },
{ key: "tianeti_municipality" },


/* ───── V ───── */
{ key: "vani" },
{ key: "vale" },
{ key: "vani_municipality" },

/* ───── Z ───── */
{ key: "zestaphoni" },
{ key: "zugdidi_municipality" },
{ key: "zestaphoni_municipality" },


// add more freely
];


// City coordinates for map default
const CITY_COORDS = {
  tbilisi: [41.7151, 44.8271],
  batumi: [41.6488, 41.6367],
  kutaisi: [42.2679, 42.7189],
  rustavi: [41.5586, 45.0252],
zugdidi: [42.5088, 41.8709], // Zugdidi, Samegrelo‑Zemo Svaneti, Georgia
telavi: [41.91957, 45.47002],       // Telavi, Georgia :contentReference[oaicite:0]{index=0}
  gori: [41.98532, 44.1129],           // Gori, Georgia :contentReference[oaicite:1]{index=1}
  bakuriani: [41.74972, 43.5325],      // Bakuriani, Georgia :contentReference[oaicite:2]{index=2}
  borjomi: [41.85272, 43.41284],       // Borjomi, Georgia :contentReference[oaicite:3]{index=3}
  gudauri: [42.4725, 44.4268],          // Gudauri, Georgia (resort area) approximate :contentReference[oaicite:4]{index=4}
  abasha: [42.20959, 42.22111],        // Abasha, Georgia :contentReference[oaicite:5]{index=5}
  ambrolauri: [42.5167, 43.15],         // Ambrolauri, approx near Rioni River basin :contentReference[oaicite:6]{index=6}
  abkhazia: [43.00697, 40.9893],        // Abkhazia – Sokhumi capital coordinates :contentReference[oaicite:7]{index=7}
  akhaldaba: [41.74972, 43.5325],       // Akhaldaba (near Bakuriani region approximate) :contentReference[oaicite:8]{index=8}
  akhaltsikhe: [41.63901, 42.98262],    // Akhaltsikhe, Georgia :contentReference[oaicite:9]{index=9}
  akhmeta: [42.03111, 45.2075], 

 ambrolauri_municipality: [42.5167, 43.15],      // Ambrolauri
  adigeni_municipality: [41.4500, 43.0333],       // Adigeni, near Akhaltsikhe
  akhaltsikhe_municipality: [41.63901, 42.98262], // Akhaltsikhe
  akhalgori_municipality: [42.7000, 44.4000],    // Akhalgori, South Ossetia region
  akhalkalaki_municipality: [41.6450, 43.5367],  // Akhalkalaki
  akhmeta_municipality: [42.03111, 45.2075],     // Akhmeta
  aspindza_municipality: [41.5022, 43.1189],     // Aspindza, near Akhaltsikhe

  bagdadi: [42.1467, 42.2300],                   // Bagdadi, near Kutaisi
  bolnisi: [41.4546, 44.7217],                   // Bolnisi

  baghdati_municipality: [42.2000, 42.1333],     // Baghdati
  bolnisi_municipality: [41.4546, 44.7217],      // Bolnisi
  borjomi_municipality: [41.85272, 43.41284],  

ckhinvali: [42.2326, 43.9738],                 // Tskhinvali
  chiatura: [42.2667, 42.5333],                 // Chiatura
  chokhatauri_municipality: [42.1333, 42.4167], // Chokhatauri
  chkhorotsku_municipality: [42.3400, 41.7500], // Chkhorotsku

  dmanisi: [41.3236, 43.2347],                  // Dmanisi
  dedoplistskaro: [41.6111, 45.0281],           // Dedoplistskaro
  dusheti: [42.0667, 44.7333],                  // Dusheti

  dedoplistskaro_municipality: [41.6111, 45.0281], // Dedoplistskaro
  dusheti_municipality: [42.0667, 44.7333],        // Dusheti
  dmanisi_municipality: [41.3236, 43.2347],        // Dmanisi

  foti: [42.1500, 41.6667],                      // Poti

  gardabani: [41.4560, 45.0390],                 // Gardabani
  gurjaani: [41.7178, 45.4672],    

 gardabani_municipality: [41.4560, 45.0390], // Gardabani
  gori_municipality: [41.9850, 43.6280],      // Gori
  gurjaani_municipality: [41.7178, 45.4672],  // Gurjaani

  java: [42.4000, 43.4000],                   // Java

  kaspi: [42.0319, 44.6379],                  // Kaspi
  kareli: [42.0225, 43.7906],                 // Kareli
  kobuleti: [41.7833, 41.7833],               // Kobuleti
  kazbegi: [42.6540, 44.6310],                // Kazbegi
  kvareli: [41.7000, 45.7000],                // Kvareli
  khashuri: [42.0667, 43.6167],               // Khashuri
  khevsureti: [42.5000, 44.8333],             // Khevsureti
  khelvachauri: [41.5200, 41.7500],           // Khelvachauri
  khobi: [42.2000, 41.8167],                  // Khobi
  khoni: [42.1000, 42.0167],     

 khoni_municipality: [42.1000, 42.0167],       // Khoni
  khulo_municipality: [41.8883, 42.2861],       // Khulo
  khashuri_municipality: [42.0667, 43.6167],    // Khashuri
  khelvachauri_municipality: [41.5200, 41.7500],// Khelvachauri
  khobi_municipality: [42.2000, 41.8167],       // Khobi
  kutaisi_municipality: [42.2667, 42.7167],     // Kutaisi
  kareli_municipality: [42.0225, 43.7906],      // Kareli
  kaspi_municipality: [42.0319, 44.6379],       // Kaspi
  kobuleti_municipality: [41.7833, 41.7833],    // Kobuleti
  kazbegi_municipality: [42.6540, 44.6310],     // Kazbegi
  kvareli_municipality: [41.7000, 45.7000],     // Kvareli
  kharagauli_municipality: [42.0900, 43.3800],  // Kharagauli
  keda_municipality: [41.6300, 41.8700],        // Keda

  lagodekhi: [41.6500, 45.3200],                // Lagodekhi
  lanchkhuti: [42.0500, 42.0000],               // Lanchkhuti
  lentekhi_municipality: [42.5800, 42.6700],    // Lentekhi
  lanchkhuti_municipality: [42.0500, 42.0000],  // Lanchkhuti
  lagodekhi_municipality: [41.6500, 45.3200],   

 manglisi: [41.5500, 44.5000],                  // Manglisi
  marneuli: [41.4567, 44.7817],                 // Marneuli
  martvili: [42.3850, 42.5230],                 // Martvili
  mestia: [43.0544, 42.7367],                   // Mestia
  mtskheta: [41.8450, 44.7170],                 // Mtskheta

  mtskheta_municipality: [41.8450, 44.7170],   // Mtskheta
  mestia_municipality: [43.0544, 42.7367],     // Mestia
  martvili_municipality: [42.3850, 42.5230],   // Martvili
  abashi_municipality: [42.4167, 42.5167],     // Abasha
  marneuli_municipality: [41.4567, 44.7817],   // Marneuli

  ninotsminda: [41.1667, 43.4667],             // Ninotsminda
  ninotsminda_municipality: [41.1667, 43.4667], // Ninotsminda

  oni: [42.8667, 43.0333],                      // Oni
  oni_municipality: [42.8667, 43.0333],        // Oni
  ozurgeti: [42.2667, 42.2667],                // Ozurgeti
  ozurgeti_municipality: [42.2667, 42.2667],   // Oz

sachkhere: [42.4167, 43.1333],                // Sachkhere
  senaki: [42.3167, 42.3167],                   // Senaki
  sagarejo: [41.9333, 45.8333],                 // Sagarejo
  samtredia: [42.1667, 42.3333],                // Samtredia
  signagi: [41.6167, 45.3167],                  // Signagi

  sachkhere_municipality: [42.4167, 43.1333],  // Sachkhere
  senaki_municipality: [42.3167, 42.3167],     // Senaki
  sagarejo_municipality: [41.9333, 45.8333],   // Sagarejo
  sighnaghi_municipality: [41.6167, 45.3167],  // Signagi
  shuakhevi_municipality: [41.7000, 42.2000],  // Shuakhevi (near Batumi)
  samtredia_municipality: [42.1667, 42.3333],  // Samtredia

  tskhinvali_district: [42.2333, 43.9667],     // Tskhinvali
  tetritskaro: [41.4000, 45.1167],             // Tetritskaro
  terjola: [42.2667, 42.3333],                 // Terjola
  tkibuli: [42.1333, 42.6167],                 // Tkibuli
  tsageri: [42.4500, 42.5667],                 // Tsageri
  tsalenjikha: [42.1000, 41.7000],             // Tsalenjikha
  tsalka: [41.6000, 43.3833],                  // Tsalka
  tsnori: [41.5833, 45.8333],                  // Tsnori
  tskaltubo: [42.2667, 42.6667], 

tkibuli_municipality: [42.1333, 42.6167],      // Tkibuli
  terjola_municipality: [42.2667, 42.3333],      // Terjola
  tetritskaro_municipality: [41.4000, 45.1167],  // Tetritskaro
  telavi_municipality: [41.9167, 45.7833],       // Telavi
  tsalka_municipality: [41.6000, 43.3833],       // Tsalka
  tsalenjikha_municipality: [42.1000, 41.7000],  // Tsalenjikha
  tsageri_municipality: [42.4500, 42.5667],      // Tsageri
  tskaltubo_municipality: [42.2667, 42.6667],    // Tskaltubo
  tianeti_municipality: [42.1500, 44.8500],      // Tianeti

  vani: [42.1667, 42.6667],                      // Vani
  vale: [41.6000, 42.3500],                      // Vale
  vani_municipality: [42.1667, 42.6667],        // Vani

  zestaphoni: [42.1667, 42.4167],                // Zestaphoni
  zugdidi_municipality: [42.5167, 41.8667],      // Zugdidi
  zestaphoni_municipality: [42.1667, 42.4167],   // Zestaphoni
};


const DISTRICT_COORDS = {
  vakesaburtalo: [41.714, 44.755],        // Vake–Saburtalo
  didubechughureti: [41.7118, 44.7937],     // Didube–Chughureti
  isanisamgori: [41.6807, 44.8702],         // Isani–Samgori
  gldaninadzaladevi: [41.79, 44.81],    // Gldani–Nadzaladevi
  oldTbilisi: [41.693, 44.803],           // Old Tbilisi
  suburbsOfTbilisi: [41.65, 44.75],     // Tbilisi suburbs (avg point)
};


const LOCALAREA_COORDS = {
  batumi: {
    bt_kakhabris_ubani: [41.61, 41.62],
    bt_tamaris_dasakhleba: [41.6488, 41.6796],
    bt_boni_gorodski: [41.641796, 41.663701],
    bt_makhinjauri: [41.68, 41.70],
    bt_dzveli_batumi: [41.65, 41.64],
    bt_rustaveli: [41.500, 41.6333],
    bt_bagrationi: [41.6375, 41.6431],
    bt_aghmasheneb: [41.632, 41.629],
    bt_javakhishvili: [41.635, 41.615],
    bt_khimshiashvili: [41.64, 41.61],
    bt_aeroport: [41.61, 41.61]
  },

  kutaisi: {
    kt_bzholebi: [42.266, 42.694],
    kt_mtsvanekhvavila: [42.16, 42.42],
    kt_balakhvani: [42.27, 42.69],
    kt_ninoshvili: [42.268, 42.705],
    kt_avtoqarkhana: [42.2783, 42.6644],
    kt_shaomiani: [42.26, 42.70],
    kt_steklotara: [42.2710, 42.7175],
    kt_aghmashenebeli: [42.268, 42.715],
    kt_nikea: [42.2345, 42.6922],
    kt_mepetubani: [42.271, 42.701],
    kt_pasiloki: [42.2597, 42.6764],
    kt_asatiani: [42.255268, 42.696710],
    kt_gora: [42.27, 42.69],
    kt_sapichkhia: [42.26, 42.69],
    kt_saghoria: [42.27, 42.70],
    kt_avangardi: [42.27, 42.71],
    kt_choma: [42.2792, 42.7079],
    kt_zastava: [42.26, 42.67],
    kt_chavchavadze: [42.2725, 42.6958],
    kt_plashadka: [42.2494, 42.7126]
  }
};

const NEIGHBORHOOD_COORDS = {
  vakesaburtalo: {
    vake: [41.7071, 44.7750],
    bagebi: [41.7061, 44.7335],
    agaraki: [41.75, 44.70],
    turtle_lake: [41.7003, 44.7542],
    tkhinvala: [41.7462, 44.7023],
    didi_digomi: [41.7902, 44.7510],
    vashlijvari: [41.7553, 44.7620],
    lisi: [41.7431, 44.7351],
    saburtalo: [41.7259, 44.7504],
    koshigora: [41.817638, 44.762907],
    patara_digomi: [41.8107, 44.7822],
    sop_digomi: [41.771858, 44.738338],
    dighmis_tchala: [41.791, 44.753],
    didgori: [41.6717, 44.6545]
  },

  didubechughureti: {
    ivertubani: [41.73, 44.83],
    kukia: [41.7145, 44.8110],
    svanetisubani: [41.709301, 44.815458],
    chughureti: [41.7392, 44.7807],
    didube: [41.7523, 44.7800],
    digmis_masivi: [41.76, 44.77],
    arsenali: [41.7059, 44.8108]
  },

  isanisamgori: {
    vazisubani: [41.6964, 44.8569],
    isani: [41.6911, 44.8132],
    metromsheni: [41.6868, 44.8348],
    navtlughi: [41.68, 44.9],
    ponitchala: [41.65, 44.91],
    airport_sett: [41.6692, 44.9546],
    aprika: [41.67, 44.91],
    varketili: [41.69, 44.87],
    dampalo: [41.6937, 44.8845],
    moscow_ave: [41.675514, 44.879257],
    samgori: [41.69, 44.85],
    "3rd_masivi" : [41.686470, 44.878610]
  },

  gldaninadzaladevi: {
    avtchala: [41.8073, 44.7943],
    gldanula: [41.8124, 44.8186],
    gldani: [41.7890, 44.8108],
    sop_gldani: [41.8221, 44.8301],
    temka: [41.77, 44.78],
    koniaki_sett: [41.7935, 44.8008],
    tbilisi_sea: [41.7494, 44.8456],
    mukhiani: [41.7863, 44.8255],
    zahesi: [41.8279, 44.7562],
    zgvisubani: [41.777, 44.820],
    lotkini: [41.73, 44.81],
    avshniani: [41.7742, 44.8307],
    nadzaladevi: [41.7326, 44.7969],
    grmaghele: [41.7655, 44.7899],
    giorgitsminda_sett: [41.8050, 44.8484]
  },

  oldTbilisi: {
    abanotubani: [41.6878, 44.8111],
    avlabari: [41.6926, 44.8152],
    vera: [41.7097, 44.7860],
    elia: [41.6978, 44.8394],
    mtatsminda: [41.695, 44.789],
    ortatchala: [41.6787, 44.8198],
    metekhi: [41.6907, 44.8121],
    rike: [41.6920, 44.8105],
    sololaki: [41.69, 44.80],
    krtsanisi: [41.6834, 44.8240],
    kharpukhi: [41.6846, 44.8200],
    tsavkisi_valley: [41.6739, 44.7604]
  },

  suburbsOfTbilisi: {
    aakhaldaba: [41.754943, 44.786030],
    betania: [41.678, 44.635],
    tsveri: [43.8860444, 42.072123],
    kiketi: [41.6567, 44.6750],
    kojori: [41.662157, 44.707301],
    kaklebi: [41.7071, 44.7126],
    okrokana: [41.6857, 44.7682],
    tabakhmela: [41.6522, 44.7532],
    shindisi: [41.67, 44.77],
    tsavkisi: [41.6667, 44.7500],
    tskneti: [41.6969, 44.7006],
    tsodoreti: [41.8333, 44.6667],
    kveseti: [41.67, 44.60],
    upper_lisi: [41.7135, 44.7187],
    mskhaldidi: [41.7400, 44.6269]
  }
};


/* CITY GROUPING HELPERS (USED BY UI LOGIC) */

// Cities that REQUIRE districts
const CITIES_WITH_DISTRICTS = ["tbilisi"];

// Cities that HAVE neighborhoods (based on district)
const CITIES_WITH_NEIGHBORHOODS = ["tbilisi"];

// Cities that HAVE local areas instead of districts
const CITIES_WITH_LOCALAREAS = ["batumi", "kutaisi"];





/* DISTRICTS */
const DISTRICTS = {
  tbilisi: [
  { value: "vakesaburtalo" },
  { value: "didubechughureti" },
  { value: "isanisamgori" },
  { value: "gldaninadzaladevi" },
  { value: "oldTbilisi" },
  { value: "suburbsOfTbilisi" }
],
};

/* LOCALAREAS */
const LOCALAREAS = {
  batumi: [
  { value: "bt_kakhabris_ubani" },
  { value: "bt_tamaris_dasakhleba" },
  { value: "bt_boni_gorodski" },
  { value: "bt_makhinjauri" },
  { value: "bt_dzveli_batumi" },
  { value: "bt_rustaveli" },
  { value: "bt_bagrationi" },
  { value: "bt_aghmasheneb" },
  { value: "bt_javakhishvili" },
  { value: "bt_khimshiashvili" },
  { value: "bt_aeroport" }
],


  kutaisi: [
  { value: "kt_bzholebi" },
  { value: "kt_mtsvanekhvavila" },
  { value: "kt_balakhvani" },
  { value: "kt_ninoshvili" },
  { value: "kt_avtoqarkhana" },
  { value: "kt_shaomiani" },
  { value: "kt_steklotara" },
  { value: "kt_aghmashenebeli" },
  { value: "kt_nikea" },
  { value: "kt_mepetubani" },
  { value: "kt_pasiloki" },
  { value: "kt_asatiani" },
  { value: "kt_gora" },
  { value: "kt_sapichkhia" },
  { value: "kt_saghoria" },
  { value: "kt_avangardi" },
  { value: "kt_choma" },
  { value: "kt_zastava" },
  { value: "kt_chavchavadze" },
  { value: "kt_plashadka" }
]



};

/* NEIGHBORHOODS (ONLY TBILISI) */
const NEIGHBORHOODS = {
      vakesaburtalo: [
      "vake",
      "bagebi",
      "agaraki",
      "turtle_lake",
      "tkhinvala",
      "didi_digomi",
      "vashlijvari",
      "lisi",
      "saburtalo",
      "koshigora",
      "patara_digomi",
      "sop_digomi",
      "dighmis_tchala",
      "didgori",
    ],

    didubechughureti: [
      "ivertubani",
      "kukia",
      "svanetisubani",
      "chughureti",
      "didube",
      "digmis_masivi",
      "arsenali",
    ],

    isanisamgori: [
      "vazisubani",
      "isani",
      "metromsheni",
      "navtlughi",
      "ponitchala",
      "airport_sett",
      "aprika",
      "varketili",
      "dampalo",
      "moscow_ave",
      "samgori",
      "3rd_masivi"
    ],

      gldaninadzaladevi: [
      "avtchala",
      "gldanula",
      "gldani",
      "sop_gldani",
      "temka",
      "koniaki_sett",
      "tbilisi_sea",
      "mukhiani",
      "zahesi",
      "zgvisubani",
      "lotkini",
      "avshniani",
      "nadzaladevi",
      "grmaghele",
      "giorgitsminda_sett",
    ],

    oldTbilisi: [
      "abanotubani","avlabari","vera","elia","mtatsminda","ortatchala",
      "metekhi","rike","sololaki","krtsanisi","kharpukhi","tsavkisi_valley"
    ],
    suburbsOfTbilisi: [
      "aakhaldaba","betania","tsveri","kiketi","kojori","kaklebi",
      "okrokana","tabakhmela","shindisi","tsavkisi","tskneti","tsodoreti",
      "kveseti","upper_lisi","mskhaldidi"
    ],
   };

export default function StepLocation({ listing, setListing, onBack, onNext }) {
  const { t, i18n } = useTranslation();

  const [showAllCities, setShowAllCities] = useState(false);
  const [addressQuery, setAddressQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const selectedCity = listing.city;
  const hasDistricts = CITIES_WITH_DISTRICTS.includes(selectedCity);
  const hasNeighborhoods = CITIES_WITH_NEIGHBORHOODS.includes(selectedCity);
  const hasLocalAreas = CITIES_WITH_LOCALAREAS.includes(selectedCity);

  const POPULAR_CITIES = CITY_OPTIONS.slice(0, 4);
  const visibleCities = showAllCities ? CITY_OPTIONS : POPULAR_CITIES;

  // 🌍 Map center
  const mapCenter = useMemo(() => {
    if (
      listing.neighborhood &&
      listing.district &&
      NEIGHBORHOOD_COORDS[listing.district]?.[listing.neighborhood]
    ) {
      return NEIGHBORHOOD_COORDS[listing.district][listing.neighborhood];
    }
    if (listing.district && DISTRICT_COORDS[listing.district]) {
      return DISTRICT_COORDS[listing.district];
    }
    if (
      listing.localarea &&
      listing.city &&
      LOCALAREA_COORDS[listing.city]?.[listing.localarea]
    ) {
      return LOCALAREA_COORDS[listing.city][listing.localarea];
    }
    if (listing.city && CITY_COORDS[listing.city]) {
      return CITY_COORDS[listing.city];
    }
    return [41.7151, 44.8271];
  }, [
    listing.city,
    listing.district,
    listing.neighborhood,
    listing.localarea,
  ]);

  
const isLocationHierarchyReady = useMemo(() => {
if (!listing.city) return false;

  if (hasDistricts && !listing.district) return false;
  if (hasNeighborhoods && !listing.neighborhood) return false;
  if (hasLocalAreas && !listing.localarea) return false;

  return true;
}, [
  listing.city,
  listing.district,
  listing.neighborhood,
  listing.localarea,
  hasDistricts,
  hasNeighborhoods,
  hasLocalAreas,
]);


const isLocationComplete = useMemo(() => {
  if (!listing.city) return false;

  if (hasDistricts && !listing.district) return false;
  if (hasNeighborhoods && !listing.neighborhood) return false;
  if (hasLocalAreas && !listing.localarea) return false;

  if (listing.lat == null || listing.lng == null) return false;

  // ✅ STREET NAME REQUIRED (Nominatim OR manual)
  const streetNameValid =
    typeof listing.street === "object" &&
    Object.values(listing.street).some(
      v => typeof v === "string" && v.trim().length > 0
    );

  if (!streetNameValid) return false;

  // ✅ STREET NUMBER REQUIRED
  if (!listing.streetNumber || !listing.streetNumber.trim()) return false;

  return true;
}, [
  listing.city,
  listing.district,
  listing.neighborhood,
  listing.localarea,
  listing.lat,
  listing.lng,
  listing.street,
  listing.streetNumber,
  hasDistricts,
  hasNeighborhoods,
  hasLocalAreas,
]);



  // 🏙 CITY
  const handleCitySelect = (cityKey) => {
  const coords = CITY_COORDS[cityKey];

  setListing(prev => ({
    ...prev,
    city: cityKey,
    district: "",
    neighborhood: "",
    localarea: "",
    lat: coords ? coords[0] : null,
    lng: coords ? coords[1] : null,
    locationApproximate: true,
  }));

  setShowAllCities(false);
};

  // 🏘 DISTRICT
  const handleDistrictSelect = (districtValue) => {
    const coords = DISTRICT_COORDS[districtValue];

    setListing(prev => ({
      ...prev,
      district: districtValue,
      neighborhood: "",
      localarea: "",
      street: {},
      streetNumber: "",
      manualStreet: false,
      fullAddress: {},
      lat: coords ? coords[0] : prev.lat,
      lng: coords ? coords[1] : prev.lng,
      locationApproximate: true,
    }));
  };

  // 🧭 NEIGHBORHOOD
  const handleNeighborhoodSelect = (neighborhoodValue) => {
    const coords =
      NEIGHBORHOOD_COORDS[listing.district]?.[neighborhoodValue];

    setListing(prev => ({
      ...prev,
      neighborhood: neighborhoodValue,
      street: {},
      streetNumber: "",
      manualStreet: false,
      fullAddress: {},
      lat: coords ? coords[0] : prev.lat,
      lng: coords ? coords[1] : prev.lng,
      locationApproximate: true,
    }));
  };

  // 📍 LOCAL AREA
  const handleLocalAreaSelect = (localareaValue) => {
    const coords =
      LOCALAREA_COORDS[listing.city]?.[localareaValue];

    setListing(prev => ({
      ...prev,
      localarea: localareaValue,
      street: {},
      streetNumber: "",
      manualStreet: false,
      fullAddress: {},
      lat: coords ? coords[0] : prev.lat,
      lng: coords ? coords[1] : prev.lng,
      locationApproximate: true,
    }));
  };

  // 🗺 MAP MOVE
  const handleMapChange = (lat, lng) => {
    setListing(prev => ({
      ...prev,
      lat,
      lng,
      locationApproximate: true,
    }));
  };

  // 🔍 NOMINATIM SEARCH
  const searchAddress = async () => {
    if (!addressQuery || addressQuery.length < 3) return;

    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?` +
          new URLSearchParams({
            q: addressQuery,
            format: "json",
            addressdetails: "1",
            limit: "5",
            countrycodes: "ge",
          }),
        {
          headers: {
            Accept: "application/json",
            "Accept-Language": i18n.language,
          },
        }
      );

      const data = await res.json();
      setSearchResults(data);
    } catch (err) {
      console.error("Nominatim search failed", err);
    }
  };

  // 🔄 RESET SEARCH ON LOCATION CHANGE
  useEffect(() => {
    setAddressQuery("");
    setSearchResults([]);
  }, [
    listing.city,
    listing.district,
    listing.neighborhood,
    listing.localarea,
  ]);

return (
  <div className="step">
    <h2>{t("common.location")}</h2>

    {/* 1️⃣ CITY */}
    <div className="location-section">
      <div className="location-title">{t("common.city")}</div>

      <div className="location-grid">
        {visibleCities.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => handleCitySelect(c.key)}
            className={
              selectedCity === c.key
                ? "active-location-btn"
                : "location-btn"
            }
          >
            {t(`location.${c.key}`, c.key)}
          </button>
        ))}
      </div>

      {!showAllCities && CITY_OPTIONS.length > POPULAR_CITIES.length && (
        <button
          type="button"
          onClick={() => setShowAllCities(true)}
          className={t("location-load-more")}
        >
          {t("Look_for_more")}
        </button>
      )}
    </div>

    {/* 2️⃣ DISTRICT */}
    {hasDistricts && (
      <div className="location-section">
        <div className="location-title">{t("common.district")}</div>

        <div className="location-grid">
          {DISTRICTS[selectedCity]?.map((district) => (
            <button
              key={district.value}
              type="button"
              onClick={() => handleDistrictSelect(district.value)}
              className={
                listing.district === district.value
                  ? "active-location-btn"
                  : "location-btn"
              }
            >
              {t(`location.${district.value}`, district.value)}
            </button>
          ))}
        </div>
      </div>
    )}

    {/* 3️⃣ NEIGHBORHOOD */}
    {hasNeighborhoods && listing.district && (
      <div className="location-section">
        <div className="location-title">
          {t("common.neighborhood")}
        </div>

        <div className="location-grid">
          {NEIGHBORHOODS[listing.district]?.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => handleNeighborhoodSelect(n)}
              className={
                listing.neighborhood === n
                  ? "active-location-btn"
                  : "location-btn"
              }
            >
              {t(`location.${n}`, n)}
            </button>
          ))}
        </div>
      </div>
    )}

    {/* 4️⃣ LOCAL AREA */}
    {hasLocalAreas && (
      <div className="location-section">
        <div className="location-title">{t("common.area")}</div>

        <div className="location-grid">
          {LOCALAREAS[selectedCity]?.map((a) => (
            <button
              key={a.value}
              type="button"
              onClick={() => handleLocalAreaSelect(a.value)}
              className={
                listing.localarea === a.value
                  ? "active-location-btn"
                  : "location-btn"
              }
            >
              {t(`location.${a.value}`, a.value)}
            </button>
          ))}
        </div>
      </div>
    )}

    {/* 🔍 ADDRESS SEARCH */}
    <div className="location-section">
      <div className="location-title">
        {t("common.search_address")}
      </div>

      <div className="location-search">
        <input
          disabled={!isLocationHierarchyReady}
          placeholder={
            isLocationHierarchyReady
              ? t("common.search_placeholder")
              : t("common.select_location_first")
          }
          value={addressQuery}
          onChange={(e) => {
  const value = e.target.value;
  const isGeorgian = i18n.language === "ka";

  const isValid = isGeorgian
    ? GEO_ONLY_REGEX.test(value)
    : EN_GEO_REGEX.test(value);

  if (!isValid) return;
  setAddressQuery(value);
}}
        />

        <button
          type="button"
          onClick={searchAddress}
          disabled={!isLocationHierarchyReady}
          className="search-btn"
        >
          {t("common.search")}
        </button>

        {searchResults.length > 0 && (
          <div className="location-results">
            {searchResults.map((r) => (
              <div
                key={r.place_id}
                className="location-result-item"
  onClick={() => {
  setListing((prev) => ({
    ...prev,
    lat: Number(r.lat),
    lng: Number(r.lon),
    locationApproximate: false,
    manualStreet: false,

    street: {
      ...(prev.street || {}),
      [i18n.language]:
        r.address?.road ||
        r.address?.neighbourhood ||
        "",
    },

    fullAddress: {
      ...(prev.fullAddress || {}),
      [i18n.language]: r.display_name,
    },
  }));

  // ✅ close dropdown + clear input
  setSearchResults([]);
  setAddressQuery("");
}}

           >
                {r.display_name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

    {/* 🗺 MAP */}
    <div className="location-section">
    <div className="location-title">
    {t("location.select_on_map")}
    </div>

    <LocationPickerMap
        center={mapCenter}
        lat={listing.lat}
        lng={listing.lng}
        onChange={handleMapChange}
      />
    </div>

 <input
  type="text"
  value={
    listing.street?.[i18n.language] ||
    listing.street?.en ||
    ""
  }
  placeholder={t("common.street_name")}
  disabled={!listing.manualStreet}
  onChange={(e) => {
    if (!listing.manualStreet) return;

    const value = e.target.value;
    const isGeorgian = i18n.language === "ka";
    const isValid = isGeorgian
      ? GEO_ONLY_REGEX.test(value)
      : EN_GEO_REGEX.test(value);

    if (!isValid) return;

    setListing((prev) => ({
      ...prev,
      street: {
        ...(prev.street || {}),
        [i18n.language]: value,
      },
    }));
  }}
/>

<label style={{ marginTop: 8, display: "block" }}>
  <input
    type="checkbox"
    checked={listing.manualStreet || false}
    onChange={(e) =>
      setListing((prev) => ({
        ...prev,
        manualStreet: e.target.checked,
      }))
    }
  />
  {t("common.write_street_manually")}
</label>


<input
  type="text"
  placeholder={t("common.street_number")}
  value={listing.streetNumber || ""}
  onChange={(e) =>
    setListing((prev) => ({
      ...prev,
      streetNumber: e.target.value,
    }))
  }
/>



    {/* ⏭ NAVIGATION */}
    <StepNavigation
      onBack={onBack}
      onNext={onNext}
      nextDisabled={!isLocationComplete}
    />
  </div>
 );
}
